import React, { FC, useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { memberMobx } from '@mobxStore'
import './index.scss'

// interface
interface IProps {
  info: any;
  onEdit?: (info: any) => void;
  onSelect?: (info: any) => void;
  onDelete?: (info: any) => void;
  onDefault?: (info: any) => void;
}
let timeFn: any
let startTime: number
const MyAddressItem: FC<IProps> = (props: IProps) => {
  const { info, onEdit, onSelect, onDelete, onDefault } = props
  const [isOpera, setIsOpera] = useState<boolean>(false)
  const { operaAddress, setOperaAddress } = memberMobx
  const refDom: any = useRef<any>(null)
  const beginTime = (e: any) => {
    e.stopPropagation()
    startTime = new Date().valueOf()
    timeFn = setTimeout(() => {
      setIsOpera(true)
      setOperaAddress(info)
    }, 1000)
  }
  const moveTime = (e: any) => {
    e.stopPropagation()
    if (timeFn) {
      clearTimeout(timeFn)
      timeFn = null
    }
  }
  const endTime = (e: any) => {
    e.stopPropagation()
    if (timeFn) {
      clearTimeout(timeFn)
      timeFn = null
    }
  }
  const outClick = (e: any) => {
    if (refDom.current && !refDom.current.contains(e.target)) {
      setIsOpera(false)
    }
  }
  useEffect(() => {
    document.body.addEventListener('click', outClick)
    return () => {
      document.body.removeEventListener('click', outClick)
    }
  }, [])
  useEffect(() => {
    if (operaAddress && info) {
      if (operaAddress.memberAddressId !== info.memberAddressId) setIsOpera(false)
    }
  }, [operaAddress, info])
  return (
    <div className='my-address-item' ref={refDom}>
      {
        isOpera &&
          <div
            className='opera-block'
            data-cypid={`addressItemOpera_${info?.memberAddressId}`}
            onClick={(e: any) => {
              e.stopPropagation()
              setIsOpera(false)
            }}
          >
            {/* {
              !info.isDefault &&
                <div
                  className='btn' onClick={(e: any) => {
                    e.stopPropagation()
                    setIsOpera(false)
                    onDefault && onDefault(info)
                  }}
                >
                  <span>{i18n.t('common.setAsDefault')}</span>
                </div>
            } */}
            <div
              className='btn del' data-cypid={`addressItemDel_${info?.memberAddressId}`} onClick={(e: any) => {
                e.stopPropagation()
                setIsOpera(false)
                onDelete && onDelete(info)
              }}
            >
              <span>{i18n.t('common.delete')}</span>
            </div>
          </div>
      }
      <div
        className='address-block'
        onTouchStart={beginTime}
        onTouchMove={moveTime}
        onTouchEnd={endTime}
        data-cypid={`addressItemBlock_${info?.memberAddressId}`}
        onClick={(e: any) => {
          e.stopPropagation()
          if (onSelect) {
            onSelect(info)
          } else if (onEdit) {
            onEdit(info)
          }
        }}
      >
        <div className='left'>
          <div className='address-area'>
            {info.isDefault && <div className='tag-item default'>{i18n.t('common.default')}</div>}
            {info.tag && <div className='tag-item'>{info.tag}</div>}
            <div className='address-info'>{info.province ? `${info.province},` : ''}{info.city ? `${info.city},` : ''}{info.district || ''} {info.address || ''}{info.addressDetail || ''}</div>
          </div>
          <div className='user-area'>
            <span>{info.realName}</span>
            <span>{info.mobile}</span>
          </div>
        </div>
        <div className='right'>
          <div
            data-cypid={`addressItemRight_${info?.memberAddressId}`}
            onClick={(e: any) => {
              e.stopPropagation()
              onEdit && onEdit(info)
            }}
          ><i className='iconfont icon-edit1'></i>
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(MyAddressItem)
